export default __webpack_public_path__ + "static/media/dd.b1792c4a.jpg";